import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AgentChatController } from '../../services/agent-chat.controller';
import { AgentConversation } from '../../services/agent-chat.service';

@Component({
  selector: 'app-agent-chat',
  templateUrl: './agent-chat.component.html',
  styleUrls: ['./agent-chat.component.sass'],
  providers: [AgentChatController],
})
export class AgentChatComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('messageInput') messageInput!: ElementRef;

  inputMessage = '';
  showSidebar = true;
  deepMode = false;

  private shouldScroll = false;

  constructor(
    public ctrl: AgentChatController,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.ctrl.onStateChange = () => {
      this.shouldScroll = true;
      this.cdr.markForCheck();
    };
    this.ctrl.init();
    this.ctrl.loadConversations(1, 50);
  }

  ngAfterViewChecked(): void {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  ngOnDestroy(): void {
    this.ctrl.ngOnDestroy();
  }

  async sendMessage(): Promise<void> {
    const text = this.inputMessage.trim();
    if (!text) return;
    this.inputMessage = '';
    if (this.deepMode) {
      await this.ctrl.sendMessageAsyncMode(text);
    } else {
      await this.ctrl.sendMessage(text);
    }
  }

  stopStreaming(): void {
    this.ctrl.stopStreaming();
  }

  toggleDeepMode(): void {
    this.deepMode = !this.deepMode;
  }

  async newConversation(): Promise<void> {
    await this.ctrl.newConversation();
  }

  async selectConversation(conv: AgentConversation): Promise<void> {
    await this.ctrl.selectConversation(conv);
  }

  async deleteConversation(conv: AgentConversation, event: Event): Promise<void> {
    event.stopPropagation();
    await this.ctrl.deleteConversation(conv);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  toggleSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  formatToolName(name: string): string {
    return this.ctrl.formatToolName(name);
  }

  private scrollToBottom(): void {
    try {
      const el = this.chatContainer?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    } catch {}
  }
}
